import React from 'react'
import ProductAddComponent from '../../components/products/ProductAddComponent'

const ProductAddPage = () => {
  return (
    <>
    <div className='mb-5'>ProductAddPage</div>
    <ProductAddComponent />
    </>
  )
}

export default ProductAddPage